import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import LoginForm from './component/login/LoginForm';
import SignupForm from './component/signup/SignupForm';
import Header from './component/header/header';
import Dashboard from './component/dashboard/Dashboard';

import Sidebar from "./component/sidemenu/Sidebar";
import { AuthProvider } from './component/common/AuthContext';

import Subscribe from "component/subscribe/Subscribe";
import Profile from "component/profile/Profile";
import usePageTitle from "component/common/PageTitle";
import AccountVerified from "component/account-verified/AccountVerified";
import StockapiDayRangeData from "component/nse/stock/stock-day-range-data/StockDayRangeData";
import FifthStrikeOptionChain from "component/nse/fifthstrike/FifthStrikeOptionChain";
import NseOptionChain from "component/nse/option-chain/NseOptionChain";
import DayRangeAnalysis from "component/nse/day-range-analysis/DayRangeAnalysis";
import OptionStrikeBars from "component/nse/test/OptionStrikeBars";
import OIDataAnalysis from "component/nse/oi-oichg-analysis/OIDataAnalysis";
import BidAskBars from "component/nse/test/BidAskBars";
import StockDataAnalysis from "component/nse/stock/stock-data-analysis/StockDataAnalysis";
import CryptoApiOptionChain from "component/crypto/CryptoApiOptionChain";
import ForgotPassword from "component/forgot-password/ForgotPassword";
import FyersAccesstoken from "component/fyers-token/FyersAccessToken";
import StockSectorDataAnalysis from "component/nse/stock/stock-sector-analysis/StockSectorDataAnalysis";
import ChartData from "component/nse/tradingview-chart/ChartData";
import GreeksCalculation from "component/nse/GreeksCalculation/GreeksCalculation";
import OptionChainAnalysis from "component/nse/option-chain-analysis/OptionChainAnalysis";
import SectorialIndices from "component/nse/stock/sectorial-indices/SectorialIndices";
import ProtectedRoute from "component/common/ProtectedRoute";
import GlobalMarketData from "component/nse/global-market/GlobalMarketData";
import FIIDIISummaryData from "component/nse/fii-dii/summary/FIIDIISummaryData";
import "react-datepicker/dist/react-datepicker.css";
import BlockDeals from "component/nse/stock/block-deals/BlockDeals";
import SectorPerformance from "component/nse/stock/sector-performance/SectorPerformance";
import LogicalIndicatorValue from "component/nse/stock/logical-indicator-value/LogicalIndicatorValue";
import BuyerSellerStock from "component/nse/stock/buyer-seller-stock/BuyerSellerStock";
import Result from "component/nse/result/Result";
import StockScanner from "component/nse/stock/stock-scanner/StockScanner";
import Positional from "component/nse/stock/positional/Positional";
import StockLtpAnalysis from "component/nse/stock/stock-ltp-analysis/StockLtpAnalysis";
import AlgoDashboard from "component/algo-trade/algo-dashboard/AlgoDashboard";
import BrokersList from "component/algo-trade/brokers/BrokersList";
import AddBroker from "component/algo-trade/brokers/AddBroker";
import BrokerCredentials from "component/algo-trade/brokers/BrokerCredentials";
import BrokerSuccess from "component/algo-trade/brokers/BrokerSuccess";
import BrokerDetails from "component/algo-trade/brokers/BrokerDetails";
import StrategiesList from "component/algo-trade/strategies/StrategiesList";
import StrategyWizard from "component/algo-trade/strategies/StrategyWizard";
import StrategyDetails from "component/algo-trade/strategies/StrategyDetails";
import Orders from "component/algo-trade/trading/Orders";
import Positions from "component/algo-trade/trading/Positions";
import PodSectorStrategy from "component/algo-trade/strategies/PodSectorStrategy";
function Layout() {
  const location = useLocation();

  // Hide Header for dashboard and nifty-option-chain routes
  // const hideHeader = location.pathname.startsWith("/dashboard") || location.pathname.startsWith("/nifty-option-chain");
  const hideHeader = location.pathname.startsWith("/profile-option-chain") || location.pathname.startsWith("/stock-api-day-range-data")
    || location.pathname.startsWith("/fifth-strike-option-chain") || location.pathname.startsWith("/nse-option-chain") || location.pathname.startsWith("/day-range-analysis")
    || location.pathname.startsWith("/oi-data-analysis") || location.pathname.startsWith("/option-bar") || location.pathname.startsWith("/bars")
    || location.pathname.startsWith("/stock-sector-analysis") || location.pathname.startsWith("/stock-data-analysis") || location.pathname.startsWith("/crypto-option-chain")
    || location.pathname.startsWith("/stock-ltp-analysis")
    || location.pathname.startsWith("/option-chain-analysis")
    || location.pathname.startsWith("/chart") || location.pathname.startsWith("/greeks") || location.pathname.startsWith("/sectorial-indices")
    || location.pathname.startsWith("/global-data") || location.pathname.startsWith("/fii-dii") || location.pathname.startsWith("/block-deals")
    || location.pathname.startsWith("/sector-performance") || location.pathname.startsWith("/logical-indicator-value") 
    || location.pathname.startsWith("/buyer-seller-stock") || location.pathname.startsWith("/result")
    || location.pathname.startsWith("/stock-scanner") || location.pathname.startsWith("/positional");

  const login = location.pathname.startsWith("/login") || location.pathname.startsWith("/signup") || location.pathname.startsWith("/verified")
    || location.pathname.startsWith("/forgot-password") || location.pathname === "/";
  // Show Sidebar for dashboard and nifty-option-chain routes
  // const showSidebar =  location.pathname.startsWith("/nifty-option-chain");
  usePageTitle();
  return (
    <>
      {!hideHeader && <Header />}
      {!login && <Sidebar />}
      {/* <Header /> */}

      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<LoginForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/signup" element={<SignupForm />} />

        <Route path="/verified/*" element={<AccountVerified />} />

        {/* Protected Routes */}
        <Route path="/dashboard/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/subscribe/*" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
        <Route path="/profile/*" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/stock-api-day-range-data/*" element={<ProtectedRoute requiresSubscription><StockapiDayRangeData /></ProtectedRoute>} />
        <Route path="/fifth-strike-option-chain/*" element={<ProtectedRoute requiresSubscription><FifthStrikeOptionChain /></ProtectedRoute>} />
        <Route path="/nse-option-chain/*" element={<ProtectedRoute requiresSubscription><NseOptionChain /></ProtectedRoute>} />
        <Route path="/day-range-analysis/*" element={<ProtectedRoute requiresSubscription><DayRangeAnalysis /></ProtectedRoute>} />
        <Route path="/oi-data-analysis/*" element={<ProtectedRoute requiresSubscription><OIDataAnalysis /></ProtectedRoute>} />
        <Route path="/option-bar/*" element={<ProtectedRoute requiresSubscription><OptionStrikeBars /></ProtectedRoute>} />
        <Route path="/bars/*" element={<ProtectedRoute requiresSubscription><BidAskBars /></ProtectedRoute>} />
        <Route path="/stock-data-analysis/*" element={<ProtectedRoute requiresSubscription><StockDataAnalysis /></ProtectedRoute>} />
        <Route path="/stock-ltp-analysis/*" element={<ProtectedRoute requiresSubscription><StockLtpAnalysis /></ProtectedRoute>} />
        <Route path="/stock-sector-analysis/*" element={<ProtectedRoute requiresSubscription><StockSectorDataAnalysis /></ProtectedRoute>} />
        <Route path="/crypto-option-chain/*" element={<ProtectedRoute requiresSubscription><CryptoApiOptionChain /></ProtectedRoute>} />
        <Route path="/fyers-access-token/*" element={<ProtectedRoute><FyersAccesstoken /></ProtectedRoute>} />
        <Route path="/brokers" element={<ProtectedRoute requiresSubscription><BrokersList /></ProtectedRoute>} />
        <Route path="/brokers/add" element={<ProtectedRoute requiresSubscription><AddBroker /></ProtectedRoute>} />
        <Route path="/brokers/add/dhan" element={<ProtectedRoute requiresSubscription><BrokerCredentials brokerType="dhan" /></ProtectedRoute>} />
        <Route path="/brokers/add/fyers" element={<ProtectedRoute requiresSubscription><BrokerCredentials brokerType="fyers" /></ProtectedRoute>} />
        <Route path="/brokers/add/angel" element={<ProtectedRoute requiresSubscription><BrokerCredentials brokerType="angel" /></ProtectedRoute>} />
        <Route path="/brokers/success" element={<ProtectedRoute requiresSubscription><BrokerSuccess /></ProtectedRoute>} />
        <Route path="/brokers/:brokerId" element={<ProtectedRoute requiresSubscription><BrokerDetails /></ProtectedRoute>} />
        <Route path="/strategies" element={<ProtectedRoute requiresSubscription><StrategiesList /></ProtectedRoute>} />
        <Route path="/strategies/new/broker" element={<ProtectedRoute requiresSubscription><StrategyWizard step="broker" /></ProtectedRoute>} />
        <Route path="/strategies/new/configure" element={<ProtectedRoute requiresSubscription><StrategyWizard step="configure" /></ProtectedRoute>} />
        <Route path="/strategies/new/conditions" element={<ProtectedRoute requiresSubscription><StrategyWizard step="conditions" /></ProtectedRoute>} />
        <Route path="/strategies/new/review" element={<ProtectedRoute requiresSubscription><StrategyWizard step="review" /></ProtectedRoute>} />
        <Route path="/strategies/:strategyId" element={<ProtectedRoute requiresSubscription><StrategyDetails /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute requiresSubscription><Orders /></ProtectedRoute>} />
        <Route path="/positions" element={<ProtectedRoute requiresSubscription><Positions /></ProtectedRoute>} />
        <Route path="/strategies/pod-sector" element={<ProtectedRoute requiresSubscription><PodSectorStrategy /></ProtectedRoute>} />
        <Route path="/option-chain-analysis/*" element={<ProtectedRoute requiresSubscription><OptionChainAnalysis /></ProtectedRoute>} />
        <Route path="/chart/*" element={<ProtectedRoute requiresSubscription><ChartData /></ProtectedRoute>} />
        <Route path="/greeks/*" element={<ProtectedRoute requiresSubscription><GreeksCalculation /></ProtectedRoute>} />
        <Route path="/sectorial-indices/*" element={<ProtectedRoute requiresSubscription><SectorialIndices /></ProtectedRoute>} />
        <Route path="/global-data/*" element={<ProtectedRoute><GlobalMarketData /></ProtectedRoute>} />
        <Route path="/fii-dii/*" element={<ProtectedRoute><FIIDIISummaryData /></ProtectedRoute>} />
        <Route path="/block-deals/*" element={<ProtectedRoute requiresSubscription><BlockDeals /></ProtectedRoute>} />
        <Route path="/sector-performance/*" element={<ProtectedRoute requiresSubscription><SectorPerformance /></ProtectedRoute>} />
        <Route path="/logical-indicator-value/*" element={<ProtectedRoute requiresSubscription><LogicalIndicatorValue /></ProtectedRoute>} />
        <Route path="/buyer-seller-stock/*" element={<ProtectedRoute requiresSubscription><BuyerSellerStock /></ProtectedRoute>} />
        <Route path="/result/*" element={<ProtectedRoute requiresSubscription><Result /></ProtectedRoute>} />
        <Route path="/stock-scanner/*" element={<ProtectedRoute requiresSubscription><StockScanner /></ProtectedRoute>} />
        <Route path="/positional/*" element={<ProtectedRoute requiresSubscription><Positional /></ProtectedRoute>} />
         <Route path="/algo-dashboard/*" element={<ProtectedRoute requiresSubscription><AlgoDashboard /></ProtectedRoute>} />
        {/* Default */}
        <Route path="*" element={<LoginForm />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Layout />
      </Router>
    </AuthProvider>
  );
}
